import { render } from "./NumbersDiff.vue?vue&type=template&id=3d5afb3a&scoped=true"
import script from "./NumbersDiff.vue?vue&type=script&lang=js"
export * from "./NumbersDiff.vue?vue&type=script&lang=js"

import "./NumbersDiff.vue?vue&type=style&index=0&id=3d5afb3a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5afb3a"]])

export default __exports__